module.exports = __webpack_public_path__ + "img/logo-small.aff1de33.png";